// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Wh4kV4J","clickable":"_Q4MNYwTR","content":"_Q__2z9Sf","header":"_nA5QhYcJ","cardWithPromo":"_6GsZMdyk"};